// Mobile provides CUSTOMER_NAME, but web provides REACT_APP_CUSTOMER_NAME
export const CUSTOMER_NAME =
  process.env.CUSTOMER_NAME || process.env.REACT_APP_CUSTOMER_NAME
export const isSN = CUSTOMER_NAME === 'sportninja'
export const isCanlan = CUSTOMER_NAME === 'canlan'
